import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import ReactTable from 'react-table-v6'
import cx from 'classnames'
import { Box } from '@piconetworks/ui'
import styles from './TrComponent.module.scss'

class TrComponent extends PureComponent {

    render() {
        const { children, className } = this.props

        return (
            <ReactTable.defaultProps.TrComponent>
                <Box.Flexbox.Container alignItems='center' className={cx(styles.padding, className)}>
                    {children}
                </Box.Flexbox.Container>
            </ReactTable.defaultProps.TrComponent>
        )
    }
}

TrComponent.propTypes = {
    children: PropTypes.node,
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
}

export default TrComponent
